const Note = ({ children }) => (
    <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 text-yellow-700 mb-4 rounded">
      <p className="font-bold">Note</p>
      <p>{children}</p>
    </div>
  );
  
  export default Note;
  